/* @flow */

export default class MetaObjectTreeViewKind {
  static NO_INSTANCE_CHILDREN = 'NO_INSTANCE_CHILDREN';
  static NO_FOLDERS = 'NO_FOLDERS';
  static BOTH = 'BOTH';
}
